// @mui
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
// routes
import { paths } from 'src/routes/paths';
import { usePathname } from 'src/routes/hooks';
import { RouterLink } from 'src/routes/components';
// _mock
import { _socials } from 'src/_mock';
// components
import Logo from 'src/components/logo';
import Iconify from 'src/components/iconify';
import { HashLink } from 'react-router-hash-link';
import { useTheme } from '@mui/system';
import { useLocales } from 'src/locales';
import { Trans } from 'react-i18next';

// ----------------------------------------------------------------------



// ----------------------------------------------------------------------

export default function Footer() {

  const pathname = usePathname();

  const theme = useTheme();

  const { t } = useLocales();

  const LINKS = [
    {
      headline: t("home.luckyads"),
      children: [
        { name: t("home.about_us"), href: '#aboutus' },
        { name: t("home.contact_us"), href: paths.contact },
        { name: t("home.faqs"), href: '#faqs' },
      ],
    },
    {
      headline: t("home.legal"),
      children: [
        { name: t("home.terms_and_conditions"), href: paths.termsOfService },
        { name: t("home.privacy_policy"), href: paths.privacy },
      ],
    },
    {
      headline: t("home.contact"),
      children: [
        { name: t("home.facebook"), href: "https://www.facebook.com/luckyadscom" },
        { name: t("home.instagram"), href: "https://www.instagram.com/luckyadscom" },
        { name: t("home.linkedin"), href: "https://www.linkedin.com/company/luckyadscom" },
        { name: t("home.twitter"), href: "https://twitter.com/luckyadscom" },
      ],
    },
  ];

  const _socials = [
    {
      value: 'facebook',
      name: t('home.facebook'),
      icon: 'eva:facebook-fill',
      color: '#1877F2',
      path: 'https://www.facebook.com/caitlyn.kerluke',
    },
    {
      value: 'instagram',
      name: t('home.instagram'),
      icon: 'skill-icons:instagram',
      color: '#E02D69',
      path: 'https://www.instagram.com/caitlyn.kerluke',
    },
    {
      value: 'linkedin',
      name: t('home.linkedin'),
      icon: 'icon-park:instagram-one',
      color: '#E02D69',
      path: 'https://www.linkedin.com/in/caitlyn-kerluke',
    },
    {
      value: 'twitter',
      name: t('home.twitter'),
      icon: 'logos:twitter',
      color: '#010101',
      path: 'https://twitter.com/caitlyn_kerluke',
    }
  ];

  // const isHome = pathname === '/';

  const simpleFooter = (
    <Box
      component="footer"
      sx={{
        py: 5,
        textAlign: 'center',
        position: 'relative',
        bgcolor: 'background.default',
      }}
    >
      <Container>
        <Logo sx={{ mb: 1, mx: 'auto' }} />

        <Typography variant="caption" component="div">
          © All rights reserved
          <br /> made by
          <Link href="https://minimals.cc/"> luckyAds.com </Link>
        </Typography>
      </Container>
    </Box>
  );

  const mainFooter = (
    <Box
      component="footer"
      sx={{
        position: 'relative',
      }}
    >
      <Box sx={{
        position: 'absolute',
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "100%",
        height: "100%",
        backgroundImage: `url(/assets/images/landing-page/${theme.palette.mode === 'dark' ? "logoImage.png" : "logoLightMode.png"})`,
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        zIndex: -1,
        opacity: 0.4,
      }} />
      <Divider />


      <Container
        sx={{
          pt: 10,
          pb: 5,
          textAlign: { xs: 'center', md: 'unset' },
          position: 'relative',

        }}
      >

        <Logo sx={{ mb: 3, width: { md: 80, xs: 120 }, height: { md: 80, xs: 120 } }} />

        <Grid
          container
          justifyContent={{
            xs: 'center',
            md: 'space-between',
          }}
        >
          <Grid xs={12} md={3}>
            <Typography
              variant="body2"
              sx={{
                maxWidth: 270,
                mx: { xs: 'auto', md: 'unset' },
                fontSize: { xs: '1rem', md: '' },
              }}
            >
              <Trans
                i18nKey="home.platform_description"
                components={{
                  0: <span style={{ color: theme.palette.primary.main }} />,
                  1: <span style={{ color: theme.palette.primary.main }} />,
                  2: <span style={{ color: theme.palette.primary.main }} />,
                  3: <span style={{ color: theme.palette.primary.main }} />,
                }}
              />
            </Typography>

            <Stack
              direction="row"
              justifyContent={{ xs: 'center', md: 'flex-start' }}
              sx={{
                mt: 3,
                mb: { xs: 5, md: 0 },
              }}
            >
              {_socials.map((social) => (
                <Link component={RouterLink} key={social.name} href={social.path} target="_blank">
                  <IconButton
                    key={social.name}
                    sx={{
                      background: 'black',
                      borderRadius: '50%',
                      mx: 0.5,
                      '&:hover': {
                        bgcolor: alpha(social.color, 0.08),
                      },
                    }}
                  >
                    <Iconify color={social.color} icon={social.icon} />
                  </IconButton>
                </Link>
              ))}
            </Stack>
          </Grid>

          <Grid xs={12} md={6}>
            <Stack spacing={5} direction={{ xs: 'column', md: 'row' }}>
              {LINKS.map((list) => (
                <Stack
                  key={list.headline}
                  spacing={2}
                  alignItems={{ xs: 'center', md: 'flex-start' }}
                  sx={{ width: 1 }}
                >
                  <Typography component="div" variant="overline">
                    {list.headline}
                  </Typography>

                  {list.children.map((link) => (
                    <Link
                      key={link.name}
                      component={
                        link.href.startsWith('#')
                          ? HashLink
                          : RouterLink
                      }
                      to={link.href.startsWith('#') ? `/${link.href}` : link.href}
                      href={!link.href.startsWith('#') ? link.href : undefined}
                      smooth
                      color="inherit"
                      variant="body2"
                      target={
                        ['Facebook', 'Instagram', 'LinkedIn', 'Twitter'].includes(link.name)
                          ? '_blank'
                          : undefined
                      }
                    >
                      {link.name}
                    </Link>
                  ))}
                </Stack>
              ))}
            </Stack>
          </Grid>
        </Grid>

        <Typography variant="body2" sx={{ mt: 10 }}>
          © {new Date().getFullYear()} {t('home.copyright')}
        </Typography>
      </Container>
    </Box>
  );

  return mainFooter;
}
